import React from "react";

import { TableRow, TableCell, Skeleton, Typography } from "@mui/material";

const TablePreloader = ({ row }) => {
 const arrRow = [...Array(row)];

 return arrRow.map((row, index) => (
  <TableRow className="FstoTableRow-root" key={index}>
   <TableCell className="FstoTableCell-root FstoTableCell-body">
    <Typography variant="subtitle1">
     <Skeleton />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="80%" />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="70%" />
    </Typography>
   </TableCell>
   <TableCell className="FstoTableCell-root FstoTableCell-body">
    <Typography variant="subtitle1">
     <Skeleton />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="80%" />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="70%" />
    </Typography>
   </TableCell>
   <TableCell className="FstoTableCell-root FstoTableCell-body">
    <Typography variant="subtitle1">
     <Skeleton />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="80%" />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="70%" />
    </Typography>
   </TableCell>
   <TableCell className="FstoTableCell-root FstoTableCell-body">
    <Typography variant="subtitle1">
     <Skeleton />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="80%" />
    </Typography>
    <Typography variant="subtitle2">
     <Skeleton width="70%" />
    </Typography>
   </TableCell>

   <TableCell className="FstoTableCell-root FstoTableCell-body" align="right">
    <Skeleton />
   </TableCell>
  </TableRow>
 ));
};

export default TablePreloader;
